import SalesOrderPermitCard from 'components/account/permit/SalesOrderPermitCard';
import { useState } from 'react';
import {
  ParkZone,
  SalesLocation,
  SalesOrderStatus,
  UnifiedPermit,
} from 'types/generatedSchemaTypes';
import { SalesOrderReceipt } from '../SalesOrderReceiptClass';

const SalesOrderTicket = ({
  salesOrder,
  allowRecurringToggle = false,
  toggleRecurringCallback,
  showAttachment = false,
  isRecurring: isRecurringProp,
}: {
  salesOrder: UnifiedPermit | undefined;
  allowRecurringToggle?: boolean;
  toggleRecurringCallback?: (value: boolean | null | undefined) => void;
  showAttachment?: boolean;
  isRecurring?: boolean | null;
}) => {
  const salesOrderReceipt = new SalesOrderReceipt(salesOrder);

  const {
    orderLines,
    renewal,
    countryCode,
    orderStatus,
    isInvoicing,
    usageType,
    isRenewalDisabled,
    scheduledTerminationDate,
  } = salesOrderReceipt || {};

  const orderLine = orderLines?.[0];

  const {
    pmc,
    billingFrequency,
    billingType,
    lineTotal,
    parkingSpace,
    validity,
    quantity,
    useAdditionalDiscount,
    additionalDiscount,
    promotion,
    serviceFeeAmount,
  } = orderLine || {};
  const { parkZone, salesLocation, name } = pmc || {};

  const [isRecurringLocal, setIsRecurringLocal] = useState(renewal);
  const isControlled = !!toggleRecurringCallback;
  const isRecurring = isControlled
    ? Boolean(isRecurringProp)
    : Boolean(isRecurringLocal);
  const toggleRecurring = () => {
    const next = !isRecurring;
    if (toggleRecurringCallback) {
      toggleRecurringCallback(next);
      return;
    }
    setIsRecurringLocal(next);
  };

  return (
    <SalesOrderPermitCard
      parkZone={parkZone as ParkZone}
      country={countryCode || 'SE'}
      pmc={pmc}
      salesLocation={salesLocation as SalesLocation}
      price={lineTotal || 0}
      useAdditionalDiscount={useAdditionalDiscount || false}
      additionalDiscount={additionalDiscount}
      promotion={promotion}
      permitName={name || ''}
      setIsRecurring={toggleRecurring}
      testID="permit-edit-title-card"
      isRecurring={isRecurring || false}
      billingFrequency={billingFrequency || 'MONTHLY'}
      billingType={billingType || 'CALENDAR'}
      isInvoicing={isInvoicing}
      status={orderStatus as SalesOrderStatus}
      parkingSpaceName={parkingSpace?.name}
      allowRecurring={allowRecurringToggle}
      isRenewalDisabled={isRenewalDisabled}
      scheduledTerminationDate={scheduledTerminationDate}
      validFrom={validity?.validFrom}
      validTo={validity?.validTo}
      quantity={quantity}
      usageType={usageType ?? undefined}
      serviceFee={serviceFeeAmount ?? 0}
      showAttachment={showAttachment}
    />
  );
};

export default SalesOrderTicket;
